<template>
  <div class="full-width full-width flex-1 flex-column space-between">
    <banner-page title="תווי קנייה ברשת רמי לוי"
                 :background-position="banner.backgroundPosition"
                 :background-color="banner.backgroundColor"
                 :imgSrc="require('@/assets/super-discount/rami/discount.svg')">

      <div class="flex-column full-width full-height padding-horizontal-m">
        <div class="margin-top-l ri-large-bold-body">תווי קניה בשווי 500 ₪</div>
        <div class="ri-large-body"> הנחה של 5%</div>
        <div class="margin-top-l ri-large-bold-body">החנויות בהן התו תקף:</div>
        <img :src="require('@/assets/super-discount/rami/rami-logos.png')"/>

        <separator/>
        <expandable-section class="margin-bottom-m margin-top-s" @expand-change="logExpandChanged" >
          <template v-slot:header>
            <div class="ri-large-bold-body">כמה פרטים נוספים</div>
          </template>
          <template v-slot:content>
            <div class="full-width padding-right-xs ri-body">
              <ul >
                <li>אפשר להשתמש בתווים ברשתות הסופר הבאות, ובעוד עשרות <span class="link" @click="moreStores">רשתות אחרות</span>.</li>
                <li>אפשר לקנות תווים בשווי 1,500₪ ללקוח בכל חודש.</li>
                <li>אנחנו נשלח לך את השובר שלך בוואטסאפ. על מנת לממש את התו, יש להציג בקופה את ההודעה שהתקבלה מרייזאפ.</li>
                <li>התווים בתוקף ל־5 שנים, וניתן לממש בקניות נפרדות.
                  רייזאפ תקבל מ׳רמי לוי׳ עמלה עבור כל קניית תו דרך רייזאפ.</li>
                <li>את תנאי השימוש ב״תו המלא״ <span class="link" @click="termsAndCondition"> אפשר לקרוא כאן</span></li>
                <li>את מדיניות ביטול רכישת התווים <span class="link" @click="cancellation"> אפשר לקרוא כאן</span></li>
              </ul>
            </div>
          </template>
        </expandable-section>
      </div>
    </banner-page>
    <sticky-bottom button-text="אני רוצה תו קנייה בהנחה!" @click="goToPurchase" :disabled="purchaseDisabled">
      <template v-slot:content v-if="hasAvailableVouchers">
        <div class="ri-large-body">לרכישת תו קנייה בשווי ₪500</div>
        <div class="ri-bold-body margin-top-xxs">
          במחיר של
          <span class="ri-large-headline">475</span>
          <span class="ri-large-bold-body">₪</span>
        </div>
        <div class="ri-label margin-top-xs voucher-limit">{{voucherState}}</div>
      </template>
      <template v-slot:content v-else>

        <div class="ri-bold-body">מצטערים, נגמר לנו מלאי התווים לחודש הזה.</div>
        <div class="ri-body">זה קורה לפעמים, למרות שאנחנו ממש משתדלים שלא. כדאי לחזור לבדוק אם המלאי התחדש בעוד כמה ימים.</div>
      </template>
    </sticky-bottom>
  </div>

</template>

<script>
import BaseUI from '@riseupil/base-ui';

import StickyBottom from '@/pages/responsive-pages/authenticated/navigation-pages/super-discount/StricyBottom.vue';
import router from '@/router';
import * as LayoutConsts from '@riseupil/base-ui/src/utils/layout-consts';
import { mapActions } from 'vuex';
import BillyApi from '@/api/BillyApi';
import Segment from '@/Segment';

export default {
  name: 'RamiLeviDiscountPage',
  components: {
    StickyBottom,
    BannerPage: BaseUI.Pages.BannerPage,
    ExpandableSection: BaseUI.ExpandableSection,
    Separator: BaseUI.Separator,
  },
  data() {
    return {
      banner: {
        backgroundPosition: BaseUI.LayoutConsts.BACKGROUND_POSITION.BOTTOM_LEFT,
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
      },
      voucherStatus: undefined,
      hasAvailableVouchers: false,
    };
  },

  async created() {
    this.setAppHeaderProps({
      backgroundColorVariant: LayoutConsts.COLOR_VARIANT.GREEN,
      logoColor: BaseUI.Colors.riseupWhite,
      textColor: BaseUI.Colors.riseupWhite,
    });
    [this.voucherStatus, this.hasAvailableVouchers] = await Promise.all([
      BillyApi.voucherStatusForMember('RAMI_LEVI'),
      BillyApi.availableVouchers('RAMI_LEVI'),
    ]);

    const voucherCount = this.voucherStatus.existingValue === 0 ? 0 : this.voucherStatus.existingValue / 500;
    Segment.trackUserGot('RamiLevi_SuperDiscount_Entered', { voucherCount, hasAvailableVouchers: this.hasAvailableVouchers });
  },
  computed: {
    voucherState() {
      if (!this.voucherStatus) {
        return '';
      }
      if (this.voucherStatus.existingValue === 0) {
        return 'אפשר לרכוש עד 3 תווים בחודש';
      }
      if (this.voucherStatus.existingValue === 500) {
        return 'אפשר לרכוש עוד שני תווים החודש';
      }
      if (this.voucherStatus.existingValue === 1000) {
        return 'אפשר לרכוש עוד תו אחד החודש';
      }
      return 'רכשת 3/3 תווים החודש. אפשר לחזור ולקנות תווים בחודש הבא';
    },
    purchaseDisabled() {
      return !this.hasAvailableVouchers || !this.voucherStatus || this.voucherStatus.existingValue === this.voucherStatus.limit;
    },
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),

    async goToPurchase() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_Next_Clicked');
      await router.push({ name: 'RamiLeviPurchasePage' });
    },

    logExpandChanged() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_MoreDetails_Clicked');
    },

    moreStores() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_OtherStores_Clicked');
      window.open('https://tav.rami-levy.co.il/', '_blank');
    },
    termsAndCondition() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_TermsAndConditions_Clicked');
      // eslint-disable-next-line max-len
      window.open('https://tav.rami-levy.co.il/wp-content/uploads/2024/09/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F-%D7%94%D7%AA%D7%95-%D7%94%D7%9E%D7%9C%D7%90-2024.pdf', '_blank');
    },
    cancellation() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_Cancellation_Clicked');
      window.open('https://tav.rami-levy.co.il/', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";
.voucher-limit {
  color: $riseup_blue;
}

.link {
  color: $riseup_blue;
  cursor: pointer;
}

ul {
  list-style-position: outside;
  margin: 0;
  padding: 0  2px 0 0 ;
}
li {
  margin-top: 10px;;
}
</style>
